// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

import { useEffect, useState } from 'react'
import * as api from '../../api/client'
import { useAuth } from '../../auth/AuthContext'
import CommentThread from './CommentThread'

/**
 * Patient-profile comment thread. Providers/nurses and pharmacy staff collaborate here;
 * authors can edit/delete their own comments and @-tag teammates (in-app + email).
 */
export default function PatientComments({ patientId }: { patientId: string }) {
  const { me } = useAuth()
  const [items, setItems] = useState<api.PatientComment[]>([])

  const load = () => { api.getPatientComments(patientId).then(r => setItems(r.items)).catch(() => { /* best-effort */ }) }
  useEffect(() => { load() }, [patientId])

  return (
    <CommentThread
      items={items}
      currentAccountId={me?.account_id}
      headerNote="Comments notify the pharmacy team. Tag a teammate to alert them in-app and by email."
      onPost={(body, mentions) => api.postPatientComment(patientId, body, mentions).then(() => {})}
      onEdit={(id, body, mentions) => api.editPatientComment(patientId, id, body, mentions).then(() => {})}
      onDelete={(id) => api.deletePatientComment(patientId, id).then(() => {})}
      reload={load}
    />
  )
}
